import axios from 'axios';

const api = axios.create({
    baseURL: "https://bukafey-app.onrender.com/api" //your api URL
    // baseURL: "http://localhost:5000/api" //your api URL
});

export default api;